<template>
    <div class="item">
        <div class="item-title">{{info.name}}</div>
        <el-radio-group class="select" v-model="value">
            <el-radio v-for="item of info.permissions" :key="item.id" :label="item.id">{{item.name}}</el-radio>
        </el-radio-group>
    </div>
</template>
<script>
    export default {
        props: {
            info: Object,
        },
        data() {
            let value = this.info.permissions.filter(v => v.checked);
            return {
                value: value.length ? value[0].id : ''
            }
        }
    }
</script>
<style lang="scss" scoped>

    .item {
        margin-top: 20px;
        background-color: #fff;
        border: 1px solid $border-color;
        &-title {
            padding: 10px;
            font-size: 14px;
            color: $color-black5;
            border-bottom: 1px solid $border-color;
        }
    }

    .select {
        display: flex;
        flex-wrap: wrap;
        padding: 0 10px 10px 30px;
        :global(.el-radio) {
            width: 20%;
            margin-top: 10px;
            margin-right: 0;
            box-sizing: border-box;
        }
    }
</style>